import { render, staticRenderFns } from "./mo-modal.html?vue&type=template&id=434d6456&external"
import script from "./mo-modal.ts?vue&type=script&lang=ts&external"
export * from "./mo-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('434d6456')) {
      api.createRecord('434d6456', component.options)
    } else {
      api.reload('434d6456', component.options)
    }
    module.hot.accept("./mo-modal.html?vue&type=template&id=434d6456&external", function () {
      api.rerender('434d6456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-modal/mo-modal.vue"
export default component.exports